import { StandaloneQuotebox, StandaloneQuoteboxProps } from '@/components/Quotebox';
import { LabradorComponent, StandaloneComponent } from '@/types/component';

const SvenskdamStandaloneQuotebox: StandaloneComponent<StandaloneQuoteboxProps> = ({ ...props }) => {
  props.author = undefined;
  return <StandaloneQuotebox {...props} />;
};

export const standalone = SvenskdamStandaloneQuotebox;

const SvenskdamLabradorQuotebox: LabradorComponent = () => <SvenskdamStandaloneQuotebox />;

export default SvenskdamLabradorQuotebox;
